module.exports = __webpack_public_path__ + "static/media/Detective.664cef9a.png";